import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./ContactUs.css";
import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page" style={{textAlign: "justify"}}>
      <Helmet>
        <title>Privacy Policy | Idexcel</title>
        <meta content="idexcel privacy statement" name="keywords" />
        <meta
          content="One of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Idexcel and how we use it."
          name="description"
        />
      </Helmet>
      {/* //banner section  */}
      <section className="privacy-banner-section">
        <Container fluid style={{ display: "contents" }}>
          <Row>
            <Col lg={12}>
              <div className="banner-overlay">
                {/* You can add any overlay content here if needed */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="success-stories-section">
        <Container className="mb-5 px-xl-5">
          <h2 className="text-center mb-4 section-title">
            <span className="textgrad"> Privacy</span> Policy
          </h2>
          <p>
            This Privacy Policy describes our policies and procedures on the
            collection, use and disclosure of your information when you use the
            service and tells you about your privacy rights and how the law
            protects you.
          </p>
          <p>
            We use our personal data to provide and improve the service. By
            using the service, you agree to the collection and use of
            information in accordance with this privacy policy.
          </p>
        </Container>
      </section>
      <section>
        <Container className="my-5 px-xl-5">
          <h2 className="text-center mb-4 section-title">
            <span className="textgrad"> Collecting</span> and Using your
            Personal Data
          </h2>
          <h3 className="subtitle">Personal Data</h3>
          <p>
            While using our service, we may ask you to provide us with certain
            personally identifiable information that can be used to contact or
            identify you. personally identifiable information may include, but
            is not limited to:
          </p>
          <ul>
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Phone number</li>
            <li>Address, State, Province, ZIP/Postal code, City</li>
            <li>Usage Data</li>
          </ul>

          <h3 className="subtitle">Usage Data</h3>
          <p>Usage Data is collected automatically when using the service.</p>
          <p>
            Usage Data may include information such as your device's internet
            protocol address (e.g. IP address), browser type, browser version,
            the pages of our service that you visit, the time and date of your
            visit, the time spent on those pages, unique device identifiers and
            other diagnostic data.
          </p>
          <p>
            When you access the Service by or through a mobile device, we may
            collect certain information automatically, including, but not
            limited to, the type of mobile device you use, Your mobile device
            unique ID, the IP address of your mobile device, Your mobile
            operating system, the type of mobile internet browser you use,
            unique device identifiers and other diagnostic data.
          </p>
          <p>
            We may also collect information that your browser sends whenever you
            visit our Service or when you access the service by or through a
            mobile device.
          </p>
          <h3 className="subtitle">Tracking Technologies and Cookies</h3>
          <p>
            We use cookies and similar tracking technologies to track the
            activity on our service and store certain information. Tracking
            technologies used are beacons, tags, and scripts to collect and
            track information and to improve and analyze our service. The
            technologies We use may include:
          </p>
          <ul>
            <li>
              <span className="subtitle fw-semibold">Web Beacons. </span>
              Certain sections of our service and our emails may contain small
              electronic files known as web beacons (also referred to as clear
              gifs, pixel tags, and single-pixel gifs) that permit the company,
              for example, to count users who have visited those pages or opened
              an email and for other related website statistics (for example,
              recording the popularity of a certain section and verifying system
              and server integrity).
            </li>
          </ul>
          <p>
            Cookies can be "Persistent" or "Session" cookies. Persistent cookies
            remain on your personal computer or mobile device when you go
            offline, while session cookies are deleted as soon as you close your
            web browser.
          </p>
          <p>
            We use both Session and Persistent Cookies for the purposes set out
            below:
          </p>
          <ul>
            <li>
              <span className="subtitle fw-semibold">
                Necessary / Essential Cookies
              </span>
            </li>
          </ul>
          <p>Type: Session Cookies</p>
          <p>Administered by: Us</p>
          <p>
            Purpose: These cookies are essential to provide you with services
            available through the website and to enable you to use some of its
            features. They help to authenticate users and prevent fraudulent use
            of user accounts. Without these Cookies, the services that you have
            asked for cannot be provided, and we only use these cookies to
            provide you with those services.
          </p>
          <ul>
            <li>
              {" "}
              <span className="subtitle  fw-semibold">
                Cookies Policy / Notice Acceptance Cookies
              </span>
            </li>
          </ul>
          <p>Type: Persistent Cookies</p>
          <p>Administered by: Us</p>
          <p>
            Purpose: These Cookies identify if users have accepted the use of
            cookies on the website.
          </p>
          <ul>
            <li>
              <span className="subtitle  fw-semibold">
                Functionality Cookies
              </span>
            </li>
          </ul>
          <p>Type: Persistent Cookies</p>
          <p>Administered by: Us</p>
          <p>
            Purpose: These cookies allow us to remember choices you make when
            you use the Website, such as remembering your login details or
            language preference. The purpose of these cookies is to provide you
            with a more personal experience and to avoid you having to re-enter
            your preferences every time you use the website.
          </p>
          <h3 className="subtitle">Use of Your Personal Data</h3>
          <p>The company may use personal data for the following purposes :</p>
          <ul>
            <li>
              <span className="subtitle  fw-bold">
                To provide and maintain our service,&nbsp;
              </span>
              including to monitor the usage of our service.
            </li>
            <li>
              <span className="subtitle  fw-bold">
                For the performance of a contract:&nbsp;
              </span>
              the development, compliance and undertaking of the purchase
              contract for the products, items or services you have purchased or
              of any other contract with us through the service.
            </li>
            <li>
              <span className="subtitle  fw-bold">
                To contact you:&nbsp;
              </span>
              To contact you by email, telephone calls, SMS, or other equivalent
              forms of electronic communication, such as a mobile application's
              push notifications regarding updates or informative communications
              related to the functionalities, products or contracted services,
              including the security updates, when necessary or reasonable for
              their implementation.
            </li>
            <li>
              <span className="subtitle  fw-bold">
                To provide you&nbsp;
              </span>
              with news, special offers and general information about other
              goods, services and events which we offer that are like those that
              you have already purchased or enquired about unless you have opted
              not to receive such information.
            </li>
            <li>
              <span className="subtitle  fw-bold">
                For other purposes:&nbsp;
              </span>
              We may use your information for other purposes, such as data
              analysis, identifying usage trends, determining the effectiveness
              of our promotional campaigns and to evaluate and improve our
              Service, products, services, marketing and your experience.
            </li>
          </ul>
          <p>
            We may share your personal information in the following situations :
          </p>
          <ul>
            <li>
              <span className="subtitle  fw-bold">
                With Service Providers:&nbsp;
              </span>
              We may share your personal information with Service Providers to
              monitor and analyze the use of our Service, to contact you.
            </li>
            <li>
              <span className="subtitle  fw-bold">
                For business transfers:&nbsp;
              </span>
              We may share or transfer your personal information in connection
              with, or during negotiations of, any merger, sale of Company
              assets, financing, or acquisition of all or a portion of Our
              business to another company.
            </li>
            <li>
              <span className="subtitle  fw-bold">
                With Affiliates:&nbsp;
              </span>
              We may share your information with Our affiliates, in which case
              we will require those affiliates to honor this Privacy Policy.
              Affiliates include Our parent company and any other subsidiaries,
              joint venture partners or other companies that We control or that
              are under common control with Us.
            </li>
            <li>
              <span className="subtitle fw-bold">
                With business partners:&nbsp;
              </span>
              We may share your information with Our business partners to offer
              you certain products, services or promotions.
            </li>
            <li>
              <span className="subtitle fw-bold">With other users:&nbsp;</span>
              when you share personal information or otherwise interact in the
              public areas with other users, such information may be viewed by
              all users and may be publicly distributed outside.
            </li>
            <li>
              <span className="subtitle fw-bold">With your consent: </span>
              We may disclose your personal information for any other purpose
              with your consent.
            </li>
          </ul>
          <h3 className="subtitle">Retention of Your Personal Data</h3>
          <p>
            The Company will retain your Personal Data only for as long as is
            necessary for the purposes set out in this Privacy Policy. We will
            retain and use your Personal Data to the extent necessary to comply
            with our legal obligations (for example, if we are required to
            retain your data to comply with applicable laws), resolve disputes,
            and enforce our legal agreements and policies.
          </p>
          <p>
            The Company will also retain Usage Data for internal analysis
            purposes. Usage Data is generally retained for a shorter period,
            except when this data is used to strengthen the security or to
            improve the functionality of Our Service, or We are legally
            obligated to retain this data for longer time periods.
          </p>
          <h3 className="subtitle">Transfer of Your Personal Data</h3>
          <p>
            Your information, including Personal Data, is processed at the
            Company's operating offices and in any other places where the
            parties involved in the processing are located. It means that this
            information may be transferred to — and maintained on — computers
            located outside of your state, province, country or other
            governmental jurisdiction where the data protection laws may differ
            than those from your jurisdiction.
          </p>
          <p>
            Your consent to this Privacy Policy followed by your submission of
            such information represents your agreement to that transfer.
          </p>
          <p>
            The Company will take all steps reasonably necessary to ensure that
            your data is treated securely and in accordance with this Privacy
            Policy and no transfer of your Personal Data will take place to an
            organization or a country unless there are adequate controls in
            place including the security of your data and other personal
            information.
          </p>
          <h3 className="subtitle">Delete Your Personal Data</h3>
          <p>
            You have the right to request the deletion of your personal data
            that we have collected.
          </p>
        </Container>
      </section>
      <section className="success-stories-section">
        <Container className="my-5 px-xl-5">
          <h2 className="text-center mb-4 section-title">
            <span className="textgrad"> Disclosure</span> of Your&nbsp;
            <span className="textgrad">Personal Data</span>
          </h2>
          <h3 className="subtitle">Business Transactions</h3>
          <p>
            If the Company is involved in a merger, acquisition or asset sale,
            your Personal Data may be transferred. We will provide notice before
            your Personal Data is transferred and becomes subject to a different
            Privacy Policy.
          </p>
          <h3 className="subtitle">Law enforcement</h3>
          <p>
            Under certain circumstances, the Company may be required to disclose
            your Personal Data if required to do so by law or in response to
            valid requests by public authorities (e.g. a court or a government
            agency).
          </p>
          <h3 className="subtitle">Other legal requirements</h3>
          <p>
            The Company may disclose your Personal Data in the good faith belief
            that such action is necessary to:
          </p>
          <ul>
            <li>Comply with a legal obligation</li>
            <li>Protect and defend the rights or property of the Company</li>
            <li>
              Prevent or investigate possible wrongdoing in connection with the
              Service
            </li>
            <li>
              Protect the personal safety of Users of the Service or the public
            </li>
            <li>Protect against legal liability</li>
          </ul>
          <h3 className="subtitle">Security of Your Personal Data</h3>
          <p>
            The security of your Personal Data is important to Us but remember
            that no method of transmission over the Internet, or method of
            electronic storage is 100% secure. While We strive to use
            commercially acceptable means to protect your Personal Data, We
            cannot guarantee its absolute security.
          </p>
          <h3 className="subtitle">Children's Privacy</h3>
          <p>
            Our Service does not address anyone under the age of 13. We do not
            knowingly collect personally identifiable information from anyone
            under the age of 13. If you are a parent or guardian and you are
            aware that your child has provided Us with Personal Data, please
            contact Us. If We become aware that We have collected Personal Data
            from anyone under the age of 13 without verification of parental
            consent, we take steps to remove that information from Our servers.
          </p>
          <p>
            If We need to rely on consent as a legal basis for processing your
            information and your country requires consent from a parent, we may
            require your parent's consent before We collect and use that
            information.
          </p>
          <h3 className="subtitle">Links to Other Websites</h3>
          <p>
            Our Service may contain links to other websites that are not
            operated by Us. If you click on a third-party link, you will be
            directed to that third party's site. We strongly advise you to
            review the Privacy Policy of every site you visit.
          </p>
          <p>
            We have no control over and assume no responsibility for the
            content, privacy policies or practices of any third-party sites or
            services.
          </p>
          <h3 className="subtitle">Changes to this Privacy Policy</h3>
          <p>
            We may update Our Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page.
          </p>
          <p>
            We will let you know via email and/or a prominent notice on Our
            Service, prior to the change becoming effective and update the "Last
            updated" date at the top of this Privacy Policy.
          </p>
          <p>
            You are advised to review this Privacy Policy periodically for any
            changes. Changes to this Privacy Policy are effective when they are
            posted on this page.
          </p>
          <h3 className="subtitle">Contact Us </h3>
          <p>
            If you have any questions about this Privacy Policy, you can contact
            us :
          </p>
          <ul>
            <li>
              By visiting this page on our website:
              <a href="/contact-us" className="textDecoration">
                https://www.idexcel.com/contact-us
              </a>
            </li>
          </ul>
        </Container>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
